module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2n"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("3.")])]), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_c('h2', {
    staticClass: "h2t"
  }, [_c('span', {
    staticClass: "txbf"
  }, [_vm._v("The Headmaster")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentb"
  }, [_c('span', {
    staticClass: "word5"
  }, [_vm._v("WITHIN THIRTY MINUTES OF ARRIVING")]), _vm._v(" on campus, I knew more about the history of Chatham Country Day School than I did about any of the five schools I’d actually attended. For example, I knew that:")]), _vm._v(" "), _c('p', {
    staticClass: "blockin"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("Colonel John Rees Chatham founded the school in 1866 after serving in the Civil War as a field surgeon.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockin"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The campus sat on twenty-three picturesque acres nestled alongside Rock Creek Park in the Forest Hills neighborhood of Washington, DC.")])]), _vm._v(" "), _c('p', {
    staticClass: "blockin"
  }, [_c('span', {
    staticClass: "txit"
  }, [_vm._v("The “foundation of a Chatham education is the honor code each student signs at the start of every school year.”")])])]), _c('p', {
    staticClass: "indenta"
  }, [_c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("I knew these things because they were all featured during the five-minute welcome video that played on a continuous loop in the Founder’s Room, which is where Marcus, Margaret, and I were kept waiting until the headmaster could meet with us.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The video was impressive the first time or two we saw it, but by the fifth viewing we pretty much hated everything about the school.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I told you they were stuck-up,” Margaret commented as a pair of recent grads talked about how Chatham prepared them for the Ivy League.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked over at Marcus and noticed his jaw was locked into his “simmer face,” the tight-lipped expression that usually meant he was trying to keep his frustration from boiling over into anger.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Something wrong?” I asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No,” he said unconvincingly as he exhaled. “It’s just that you’d think they wouldn’t keep the "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(" waiting so long. Especially since "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("they")]), _vm._v(" asked "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("us")]), _vm._v(" for help.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("Unspoken but understood was the fact that from the moment we arrived, it had been obvious we were less than they’d been expecting. I’m sure the headmaster told his assistant that three "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("FBI")]), _vm._v(" agents were coming. She was anticipating men in suits with crew cuts, not Marcus and a pair of ")]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("kids. Even the request for us to wait in the Founder’s Room, instead of staying in the outer office, seemed like an insult. As if they wanted to keep us out of view until they figured out how to get rid of us.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In addition to the video, the room featured oak-paneled walls covered with photographs of graduating classes going back more than a century, shelves teeming with ancient yearbooks, and for some unexplained reason, a display case featuring the fossilized jawbone of a giant ground sloth. (The only fossil at Deal was the cafeteria lady who deep-fried the tater tots.) The inscription on the case read, “"), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Megatherium")]), _vm._v(" sample collected by Col. J. R. Chatham, on loan from the Smithsonian Institution.” I was trying to make sense of it when the headmaster’s assistant finally came to get us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Dr. Putney can see you now,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were ushered into an impressive office with antique furniture and a small sitting area. It was nothing like the principal’s office at Deal, but Putney was the headmaster of an elite prep school. People paid a lot of money for their kids to attend and I’m sure they expected a certain level of formality.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Putney was built like a runner, tall and lean, with a hawk’s nose. He wore a crisp white shirt with a burgundy tie. The reading glasses perched on the top of his balding head gave him the air of a professor.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("“Welcome,” he said as he motioned toward the sitting area. “My name is Dr. Putney and I’m the headmaster here at Chatham Country Day.”")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The greeting was polite but hardly warm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m Special Agent Rivers,” Marcus said firmly. “And this is Florian Bates and Margaret Campbell.” Then he added, “Did you have any luck reaching Admiral Douglas?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The man gave Marcus a quizzical look. “What do you mean?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s why we had to wait so long, right?” Marcus said. “Because you were trying to reach him to ask why he sent us.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am sorry you think that, but I assure you I did not try to call Admiral Douglas,” he said with a smile.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("(Detective tip #2: When people lie, they often try to cover it by using formal speech like Putney did twice in this sentence. He said, “I am” instead of “I’m” and “did not” for “didn’t.” Liars also tend to add terms like “I assure you.”)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But since you bring it up, I must admit I am confused,” he continued. “When I spoke to the admiral over the weekend, he led me to believe he was offering the help of the Special Projects Team.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s correct,” said Marcus.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("The headmaster waited to see if there was more to the ")]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("answer but there wasn’t. Then he looked at the three of us and asked, “Will they be coming soon?”")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“We are the Special Projects Team,” Marcus replied with a smile. “And I’m certain he informed you that our role must be kept a secret from everyone. Including your staff, faculty, and the board of trustees.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He eyed us again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Then I really am confused. I assumed that the team might consist of some forensics specialists to discreetly look for evidence or maybe a computer expert to figure out who hacked our server.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Forensic evidence can only help if we can fingerprint your entire student body,” Marcus said. “Do you think their parents would be okay with that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, no,” he admitted. “But . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And as for a computer expert, for that we’d need access to all of your internal files, accounts, and records storage.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, there are privacy concerns . . .”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“More important, you’re not looking for a criminal mastermind or a cyber thief. You’re looking for a kid, or perhaps a group of kids. So that’s what we’ve brought you. The quickest way to find out who’s been pulling pranks at your school is to let Florian and Margaret go undercover as visiting students.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("“Undercover?” ")]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("He practically choked on the word. “You’re not infiltrating a street gang. This is a prestigious prep school. We can’t just have them snooping around and interrogating people. Our student body is very special and—”")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“So is theirs,” Marcus interrupted again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I beg your pardon?” he asked, confused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Their student body at Alice Deal Middle School,” he said. “It’s also very special.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Of course.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“In fact,” Marcus continued, “so is the student body at every school in Washington. For example, Duke Ellington School over on Eleventh Street Northwest. That’s where I went.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m sure it’s very nice,” Putney said condescendingly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I also went to Harvard,” added Marcus. “And Georgetown for my PhD.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I didn’t mean to imply . . . ,” Putney said, backpedaling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This is when I came to his rescue. (Detective tip #3: If you help someone when you don’t need to, they’ll be more willing to help you later.) I appreciated Marcus standing up against the headmaster’s snobbiness, but I needed Putney to like us, to want us to be there. It was the only way we were going to be successful.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“Agent Rivers, I think Dr. Putney just meant that many of the students here are in a unique situation because their parents hold very public positions in the government. It’s important that what happens during this investigation doesn’t get swept up into that.”")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Exactly,” he exclaimed. “That’s all I was saying.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You have nothing to worry about, Dr. Putney,” I assured him. “We’re discreet. We’ll approach it the same way you approached your church mission. Just like when you went to Brazil and adapted to their customs, we’re guests and will respect the customs and traditions unique to Chatham while we do our work.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Marcus shot me a wink.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Y-y-yes,” he stammered, trying to make sense of what I’d just said. “But how did you know that?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How did I know what?” I asked. “That you went on a mission? Or that it was to Brazil?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Both,” he replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“"), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("TOAST")]), _vm._v(",” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Toast?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("“The Theory of All Small Things,” answered Margaret. “The idea is that little details often give away much bigger pieces of information than you think. When you add them up, you have an indisputable truth. That’s how we’re going ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("to find who’s responsible for the pranks. Florian and I are going to use "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("TOAST")]), _vm._v(".”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He looked back and forth at us like we were speaking a foreign language. “What "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("little details")]), _vm._v(" could possibly tell you that I took a mission to Brazil?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“On the wall beside your desk are your college diplomas,” I explained. “They’re from Brigham Young University. Over ninety-eight percent of the students at "), _c('span', {
    staticClass: "allcaps"
  }, [_vm._v("BYU")]), _vm._v(" are Mormon. And roughly a third of all Mormon men go on a mission.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, but that means two-thirds don’t,” he said as a challenge. “What makes you think I did?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You’re featured in the welcome video not only as the headmaster but also as a graduate of Chatham Day,” I replied. “But there’s a six-year gap from your high school graduation until the date you received your bachelor’s. That’s four years of college with two years left over for your mission.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("“As to Brazil,” Margaret said, picking up without missing a beat, “that was easy. There’s a picture of you on the far bookcase when you were about twenty years old. You’re standing in front of the giant Christ the Redeemer statue, which is in Rio. There’s also a picture of your family on your desk. It looks like a vacation shot and in it you’re wearing a yellow-and-green jersey. Anyone who plays soccer knows it’s the jersey of the Brazilian national team. I’m guessing ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("you became a fan while you lived there and you’ve continued ever since.”")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("He sat for a moment flabbergasted, unsure what to say. That’s when I decided to really show off. “We’re here to help. We understand you can’t have another embarrassment like you did with Alexis Fitzgerald.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And just like that, the color drained from his face.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The Wicked Witch of Wall Street?” asked Marcus, unsure where I was heading but delighted by the potential. “The woman who was arrested for stealing millions of dollars from charity? What does she have to do with Chatham?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“She paid for the new gym, didn’t she?” I asked Putney. “With some of the money she stole.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He let out a slow, pained breath.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We had absolutely no idea where she got it,” he said defensively. “And we’re repaying it to the charities with interest. It’s just going to take a little time.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Rich private-school kids playing in a gym paid for with money stolen from the homeless,” said Marcus. “It’s funny how I never heard about that.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Almost nobody has,” he said, looking at me. “Who told you? Admiral Douglas?”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("“Never,” I answered. “The admiral "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("keeps")]), _vm._v(" secrets. He doesn’t share them. You’re the one who told me. Or at ")]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("least your assistant did, when she made us watch "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Welcome to Chatham")]), _vm._v(" over and over again.”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("I let him sweat that for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“There are two abrupt edits in the video,” I explained. “Visually they’re fine, but the music skips both times. I had the same problem once when I was trying to make a short movie on my computer. It’s really hard to re-edit a video after you’ve added the music. Once you know that, it’s obvious something was taken out. The two cuts are where sound bites from Alexis Fitzgerald’s interview ran, right? All you had to do was clip her out. Except you forgot to have the credits redone. She’s the only person mentioned in the special thanks who’s not in the video. Of course no one ever looks at the credits. Well, almost no one.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But how did you know she donated the money for the gym?” he asked.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“When we walked by it on the way to your office, I noticed the name above the entrance is off center. It says Tate Gymnasium, but there’s way too much room over to the left. It was designed to read Fitzgerald Gymnasium. That’s the problem with chiseling names into marble. It’s hard to fix a mistake.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“And you figured out all of that while you were waiting in the Founder’s Room?” he asked.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("“Actually, I figured out more than that,” I said ominously.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("This is when he gulped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I looked her up in one of the old yearbooks and realized both of you were in the same class. That got me thinking. I bet you’re the one who called her up when you were trying to raise money for the gym. Just like you called the admiral to solve this problem. And while you’ve been able to keep the story of her involvement out of the press, the board of trustees knows it was you. They blame you. That’s why you can’t have another mistake. That’s why you need us to make this problem go away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was silence in the room for a moment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Don’t feel bad,” Marcus said. “He does that a lot.” He turned to Margaret and asked, “What do you call it again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Getting toasted,” she replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“That’s right.” Marcus smiled and turned back to Dr. Putney. “You just got toasted.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5ecf8ae","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 72
// module chunks = 0